/**
 * Inventory Balance Report
 *
 * Compares inventory balances between Lightspeed and Xero across all FPs.
 */
import BaseReportPage, { ColumnDef } from './BaseReportPage'

const columns: ColumnDef[] = [
  { key: 'fp_code', label: 'FP Code', type: 'text' },
  { key: 'franchise_name', label: 'Franchise', type: 'text' },
  { key: 'last_sync_at', label: 'Data Age', type: 'sync_status' },
  { key: 'fp_status', label: 'Status' },
  { key: 'country', label: 'Country', type: 'text' },
  { key: 'ls_total_excl_negative', label: 'LS Total (Excl Neg)', type: 'currency', error: { zero: true } },
  { key: 'ls_total_incl_negative', label: 'LS Total (Incl Neg)', type: 'currency' },
  { key: 'xero_total', label: 'Xero Total', type: 'currency', error: { zero: true } },
  { key: 'variance_excl', label: 'Variance', type: 'currency' },
  { key: 'variance_percentage_excl', label: 'Variance %', type: 'percentage', error: { thresholdPercent: 0.15 } },
  { key: 'lightspeed_sync', label: 'LS Sync', type: 'datetime' },
  { key: 'xero_sync', label: 'Xero Sync', type: 'datetime' },
]

export default function InventoryBalanceReport() {
  return (
    <BaseReportPage
      reportType="inventory_balance"
      title="Inventory Balance Comparison"
      description="Compare inventory balances between Lightspeed and Xero across all franchise partners."
      filterConfig={{
        showFpSelector: true,
        showFpStatus: true,
        showCountry: true,
        showRegion: true,
        linkFpStatusToSearch: true,
      }}
      columns={columns}
      defaultSortColumn="franchise_name"
      enableBulkActions
    />
  )
}
